var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveItem1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1566_3707",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1566_3707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9754 10.6253H7.14685V9.37533H16.9754L15.4594 7.85928L16.3375 6.95553L19.3823 10.0003L16.3375 13.0451L15.4594 12.1414L16.9754 10.6253ZM12.6677 7.38803V4.42345C12.6677 4.34859 12.6437 4.28713 12.5956 4.23908C12.5474 4.19102 12.4859 4.16699 12.4112 4.16699H4.42247C4.34761 4.16699 4.28615 4.19102 4.2381 4.23908C4.19004 4.28713 4.16602 4.34859 4.16602 4.42345V15.5772C4.16602 15.6521 4.19004 15.7135 4.2381 15.7616C4.28615 15.8096 4.34761 15.8337 4.42247 15.8337H12.4112C12.4859 15.8337 12.5474 15.8096 12.5956 15.7616C12.6437 15.7135 12.6677 15.6521 12.6677 15.5772V12.6126H13.9177V15.5772C13.9177 15.9928 13.7705 16.3478 13.476 16.6422C13.1817 16.9365 12.8268 17.0837 12.4112 17.0837H4.42247C4.00692 17.0837 3.65192 16.9365 3.35747 16.6422C3.06317 16.3478 2.91602 15.9928 2.91602 15.5772V4.42345C2.91602 4.00789 3.06317 3.6529 3.35747 3.35845C3.65192 3.06415 4.00692 2.91699 4.42247 2.91699H12.4112C12.8268 2.91699 13.1817 3.06415 13.476 3.35845C13.7705 3.6529 13.9177 4.00789 13.9177 4.42345V7.38803H12.6677Z",
    fill: "#868383"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveItem1);
export default __webpack_public_path__ + "static/media/move_item (1).7bdd396074a6a7cc38fcf164dd039e9d.svg";
export { ForwardRef as ReactComponent };